import { createAsyncCategoryHandler } from "../category-dispatcher";
import { advancedTools } from "./advanced-tools";
import { propertyTools } from "./property-tools";

/**
 * Category handler for property-related operations.
 * Consolidates property-tools (sync + async) and advanced-tools (async) handlers.
 */
// Debug: log registered operations to diagnose set_datasource_bindings dispatch
console.log(
  "[cat-property] async handler for set_datasource_bindings:",
  typeof propertyTools.async?.ui_logic_set_datasource_bindings
);

export const handlePropertyCategory = createAsyncCategoryHandler(
  {
    list_binding_options: propertyTools.sync!.ui_structure_list_binding_options,
    set_binding: propertyTools.sync!.ui_structure_set_property_binding,
    set_value_binding: propertyTools.sync!.ui_logic_set_value_binding,
    set_symbol: propertyTools.sync!.ui_logic_set_property_symbol,
    update_symbol: propertyTools.sync!.ui_logic_update_property_symbol,
    set_type: propertyTools.sync!.ui_logic_set_property_type,
    set_type_options: propertyTools.sync!.ui_logic_set_property_type_options,
    get_data_editor: propertyTools.sync!.ui_logic_get_property_data_editor,
    set_data_action: propertyTools.sync!.ui_logic_set_property_data_action
  },
  {
    set_data_field: propertyTools.async!.ui_logic_set_property_data_field,
    set_multiple_bindings: propertyTools.async!.ui_logic_set_multiple_bindings,
    set_multiple_data_fields: propertyTools.async!.ui_logic_set_multiple_data_fields,
    set_datasource_bindings: propertyTools.async!.ui_logic_set_datasource_bindings,
    get_dynamic_types: advancedTools.async!.ui_structure_get_dynamic_types
  }
);
